import HowItWorksSteps from '../../../components/feature/HowItWorksSteps';

const steps = [
  {
    icon: 'ri-edit-line',
    title: 'Tell Us About Your Car',
    description:
      'Fill out our quick form — year, make, model, mileage, condition. Takes about 2 minutes. No VIN decoder required, no essay needed.',
  },
  {
    icon: 'ri-hand-coin-line',
    title: 'Get a Real Offer',
    description:
      'We use live market data to give you a competitive cash offer within 24 hours. Not a "starting point for negotiation." An actual number.',
  },
  {
    icon: 'ri-map-pin-user-line',
    title: 'We Come to You',
    description:
      'Pick a time that works. We\'ll come inspect the vehicle wherever it is — your driveway, your office, wherever. You don\'t move a muscle.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Get Paid on the Spot',
    description:
      'We verify the condition, hand you the payment — cash, check, or direct transfer — and handle every scrap of paperwork. You\'re done.',
  },
];

export default function HowItWorks() {
  return (
    <HowItWorksSteps
      steps={steps}
      variant="grid"
      title="Four Steps. Zero Headaches."
      subtitle="We designed this process for people who have better things to do than spend a weekend selling a car."
      ctaText="Start the Process"
      ctaHref="/sell-your-car#form"
      ctaNote="Most sellers are paid within 24 hours of first contact. Some same-day."
      theme="light"
      showAnimation={false}
    />
  );
}